import React from 'react';
import { produce } from 'immer';
import classNames from 'classnames';

export class SummaryOverlay extends React.Component {
  state = {
    open: false,
  };

  onOpenClick = () => {
    this.setState(
      produce(this.state, function (draft) {
        draft.open = !draft.open;
      })
    );
  };

  render() {
    return (
      <React.Fragment>
        <div
          onClick={this.onOpenClick}
          className={classNames('WorkshopsOverlay__SummaryOverlayBackground', {
            'WorkshopsOverlay__SummaryOverlayBackground--Open': this.state.open,
          })}
        />
        <div
          className={classNames('WorkshopsOverlay__SummaryOverlay', {
            'WorkshopsOverlay__SummaryOverlay--Open': this.state.open,
          })}
        >
          <button
            type="button"
            onClick={this.onOpenClick}
            className="WorkshopsOverlay__SummaryOverlayButton"
          >
            <span className="fa fa-list" />
          </button>
          {this.props.children}
        </div>
      </React.Fragment>
    );
  }
}
